(function (angular) {
    var AuthService = (function () {
        /**
         * @param $injector{$injector}
         * @param $http{$http}
         * @param $q{$q}
         * @param $Config{$Config}
         * @param localStorageService
         * @param cacheMemoryService{CacheMemoryService}
         * @param $rootScope
         * @param RequestRejector{RequestRejector}
         * @param MKioskService{MKioskService}
         * @param $Loading{$Loading}
         * @param UtilityService{UtilityService}
         * @constructor
         */
        function AuthService($injector,$http, $q, $Config, localStorageService, cacheMemoryService, $rootScope, RequestRejector, MKioskService, $Loading, UtilityService) {
            this.apiUrl = $Config.apiUrl;
            this.$injector = $injector
            this.$http = $http;
            this.$q = $q;
            this.$Config = $Config;
            this.localStorageService = localStorageService;
            this.cacheMemoryService = cacheMemoryService;
            this.$rootScope = $rootScope;
            this.RequestRejector = RequestRejector;
            this.MKioskService= MKioskService;
            this.$loading = $Loading;
            this.utilityService = UtilityService;
            
            this._showingUpdateRequired = false; // Determine new-version-dialog is openning
            this.authenticated = false; // Determine user is authenticated after refresh home data
            
            this.showingChangePassword = false; // Is showing change password dialog
            this.changePasswordDialogRef = null; // Reference to change password dialog
        }

        AuthService.prototype = {
            getUrl: function (url) {
                return this.apiUrl + url;
            },
            platformVersion() {
                if (!this.isOnDevice) {
                    return this.getOSVersion();
                }
                return window.device.version;
            },
            getDeviceName() {
                if (!window.device) {
                    return navigator.platform;
                }
                let model = window.device.model;
                if (ionic.Platform.isIOS()) {
                    let list = iosDeviceList;
                    //console.log(list);
                    let match = list.find((item) => {
                        return item.Identifier === model;
                    });
                    if (match) {
                        return match.Name;
                    }
                }
                return model;
            },
            login: function (login, password) {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    var loginUrl = 'mobile/logon';
                    var loginData = {
                        Login: login,
                        Password: password
                    }
                    if(window.cordova){
                        //NF-821: Replace mobile/logon by  /cordova/Logon if app run on cordova
                        loginUrl = 'cordova/Logon';

                        loginData.ClientId = this.RequestRejector.getClientId();
                        loginData.Platform = ionic.Platform.isIOS() ? 'iOS' : 'Android';  // Platform: 'iOS','Android'(Default Android)
                        loginData.Version = this.$Config.getVersion(); // ex: "2024.3.0"
                        loginData.OsVersion = window.device ? window.device.version : ''; // "17.0.1"
                        loginData.DeviceName =this.getDeviceName();
                    }

                    // NF-834: Track login info but don't show password
                    try {
                        let clonedLoginData = JSON.parse(JSON.stringify(loginData));
                        if(clonedLoginData.Password) {
                            clonedLoginData.Password = '*'.repeatString(clonedLoginData.Password.length);
                        }
                        console.log('loginData', clonedLoginData);
                    } catch (e) {
                    }


                    this.$http.post(this.getUrl(loginUrl), loginData).then(angular.bind(this, function (response) {
                        var data = response.data;
                        data.Email = login;

                        this.localStorageService.set("user", data);

                        // NF-821: Show "UpdateRecommended dialog"
                        if(window.cordova && data && data.UpdateRecommended) {
                            this.showUpdateRecommendedDialog(data.InstallationUrl);
                        }
                        resolve(data);
                    }), angular.bind(this, function(error){
                        // NF-821: Show "UpdateRequired dialog" if run on cordova and UpdateRequired is true
                        if(window.cordova && error && error.data && error.data.code==='UpdateRequired') {
                            this.showUpdateRequiredDialog(error.data.data.InstallationUrl);
                            error.skipShowAPIError = true;
                        }
                        reject(error);
                    }));
                }));
            },
            isLoggedIn: function () {
                var user = this.localStorageService.get("user");
                return !!user;
            },
            logout: function () {
                return this.$q((resolve)=>{
                    let savePushNotificationRegistration = ()=> {
                        return Promise.resolve();
                    }
                    if(window['cordova'] && window['FirebasePlugin']){
                        /** @type {NotificationService} */
                        let notificationService = this.$injector.get('NotificationService') ;
                        savePushNotificationRegistration = notificationService.unregister.bind(notificationService);
                    }
                    this.$loading.show();
                    savePushNotificationRegistration().finally(()=>{
                        this.$loading.hide();

                        //Clear all Storge, Session
                        let localinfo = this.localStorageService.get("localinfo");
                        this.localStorageService.clearAll();

                        // NF-607: we dont delete local infor which contains clientId in case user logout
                        if (localinfo) {
                            this.localStorageService.set("localinfo", localinfo);
                        }

                        // Clear cache
                        this.cacheMemoryService.clean();

                        sessionStorage.removeItem("Neo-Fleet-DisplayEnergyCard");
                        sessionStorage.removeItem("home-data");
                        
                        this.authenticated = false; // Indicate app is login by call homescreen api
                        resolve();
                    });
                });
            },
            refreshHomeData: function () {
                return this.$q(angular.bind(this, function (resolve, reject) {
                    var _self = this;
                    this.MKioskService.getHomeScreenData().then( (screenData) => {

                        var user = _self.localStorageService.get("user");

                        if (user) {
                            // make sure we reset data of currently saved into local storage due to the buf that it keeop many infor
                            var userNewData = { SessionId: user.SessionId, Email: user.Email };
                            _self.localStorageService.set("user", userNewData);
                        }

                        sessionStorage.setItem("home-data",  JSON.stringify(screenData));

                        _self.$rootScope.$emit("update-profile");

                        _self.$rootScope['home-refresh-finish'] = true;
                        
                        // Set authenticated status
                        if(!this.authenticated) {
                            this.authenticated = true;
                            this.$rootScope.$emit("authorized"); // Notify app is authenticated after refresh home data
                        }
                        
                        resolve(screenData);
                    }, reject);
                }));
            },
            /**
             * 
             * @returns {IAuthenticatedUser}
             */
            getAuthenticatedUser: function () {
                var result = {};
                var user = this.localStorageService.get("user");
                if (!user) { return null; }

                _.extend(result, { SessionId:  user.SessionId});

                var homeDataString = sessionStorage.getItem("home-data");

                if (homeDataString) {
                    var homeData = JSON.parse(homeDataString);
                    _.extend(result, homeData);
                }

                return result;
            },
            updateUserProfile: function(profile) {
                var homeDataString = sessionStorage.getItem("home-data");

                if (homeDataString) {
                    var homeData = JSON.parse(homeDataString);
                    _.extend(homeData, profile);

                    sessionStorage.setItem("home-data",  JSON.stringify(homeData));

                    this.$rootScope.$emit("update-profile");
                }
            },
            sendResetPasswordEmail: function(login) {
                return  this.$http.post(this.getUrl("mobile/RequestResetPasswordEmail"), {
                    Login: login,
                    ClientId: this.RequestRejector.getClientId()
                });
            },
            validateResetPasswordToken: function(token) {
                return  this.$http.post(this.getUrl("mobile/ValidateResetPasswordToken"), {
                    Token: token
                });
            },
            generatePassword: function() {
                return  this.$http.get(this.getUrl("mobile/GeneratePassword"));
            },
            estimatePasswordStrength: function(token, login, newPass) {
                return  this.$http.post(this.getUrl("mobile/EstimatePasswordStrength"), {
                    Token: token,
                    Login: login,
                    NewPassword: newPass
                });
            },
            resetPassword: function(login, newPass, token) {
                return  this.$http.post(this.getUrl("mobile/ResetPassword"), {
                    Login: login,
                    NewPassword: newPass,
                    ClientId: this.RequestRejector.getClientId(),
                    Token: token
                });
            },
            getUserLocalValue: function(key) {
                var user = this.localStorageService.get("user");

                if(!user) {
                    return null;
                }

                var userLocals = this.localStorageService.get(user.Email);

                if (!userLocals) { return null; }

                return userLocals[key];
            },
            setUserLocalValue: function(key, value) {
                var user = this.localStorageService.get("user");

                if(!user) {
                    return null;
                }

                var userLocals = this.localStorageService.get(user.Email);

                if (!userLocals) { userLocals = {} }

                userLocals[key] = value;

                this.localStorageService.set(user.Email, userLocals);
            },
            /**
             * Checking module is enabled
             * @param name {string}
             * @returns {boolean}
             */
            isModuleEnabled: function(name){
                let auth = this.getAuthenticatedUser();
                return !!(auth && auth.Modules && auth.Modules.indexOf(name) !== -1);
            },

            getSessionId(){
                return this.getAuthenticatedUser().SessionId;
            },


            // NF-821: Checking and show new-version-dialog
            /**
             *  Show update required dialog
             * @param installationUrl {string}
             */
            showUpdateRequiredDialog: function (installationUrl) {
                // Prevent show repeat
                if (this._showingUpdateRequired) {
                    return;
                }

                this._showingUpdateRequired = true;

                // Close all dialog to show Required Update Dialog
                this.utilityService.closeAllDialog();

                var config = {
                    attachTo: angular.element(document.body),
                    controller: UpdateRequiredDialog,
                    templateUrl: 'js/shared/checking-new-version-dialog/update-required-dialog/update-required-dialog.html',
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    focusOnOpen: true,
                    hasBackdrop: true,
                    zIndex: 10000, // highest priority
                    panelClass: 'panel-md-dialog',
                    locals: {
                        installationUrl: installationUrl
                    },
                    onDomRemoved: () => {
                        this._showingUpdateRequired = false;
                    }
                };
                let $mdPanel = this.$injector.get('$mdPanel');
                $mdPanel.open(config);
            },

            /**
             * Show update recommended dialog
             * - Don't show again if user ignore update less than 8 hours
             * @param installationUrl {string}
             */
            showUpdateRecommendedDialog(installationUrl) {
                /** @type NotificationService */
                let notificationService = this.$injector.get('NotificationService');


                // Don't show updateRecommended if remaining < 8h
                let timeIgnoreUpdate = localStorage.getItem('TimeIgnoreUpdate');
                if (timeIgnoreUpdate) {
                    let duration = new Date().getTime() - parseInt(timeIgnoreUpdate);
                    if (duration < 8 * 60 * 60 * 1000) {
                        // Don't show dialog if remaining < 8h
                        return;
                    } else {
                        // Remove TimeIgnoreUpdate  and show dialog
                        localStorage.removeItem('TimeIgnoreUpdate');
                    }
                }

                notificationService.setUpdateRecommended(installationUrl);
            },

            showingUpdateRequired() {
                return this._showingUpdateRequired;
            },

            /**
             * NF-1246: Show change password dialog
             * @param mustUpdatePasswordReason {String|null} // Show close button on top left
             * @returns {void}
             */
            showChangePassword(mustUpdatePasswordReason){
                if (mustUpdatePasswordReason) {
                    // Close dialog if dialog is opening and don't have reason 
                    if (this.changePasswordDialogRef && // dialog is opening
                        !this.showingChangePassword // Change password don't have reason (open from menu)
                    ) {
                        this.changePasswordDialogRef.close().then(() => {
                            this.changePasswordDialogRef = null;
                            this.showChangePassword(mustUpdatePasswordReason);
                        });
                        return; 
                    } else {
                        // Prevent opening multiple dialog if change password have reason (home data)
                        if (this.showingChangePassword === true) {
                            return;
                        }
                        this.showingChangePassword = true;
                    }
                }

                let config = {
                    attachTo: angular.element(document.body),
                    controller: ChangePasswordController,
                    controllerAs: 'vm',
                    templateUrl: 'js/internal/changepassword/changepassword.view.html',
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    focusOnOpen: true,
                    hasBackdrop: true,
                    zIndex: mustUpdatePasswordReason ? 1001: 80 , // default(80)
                    fullscreen: true,
                    onDomAdded: ()=>{
                        $("#change-password-modal").parent().addClass("panel-dialog");
                    },
                    onDomRemoved: ()=>{
                        if(mustUpdatePasswordReason){
                            this.showingChangePassword = false;
                        }
                    },
                    locals: {
                        mustUpdatePasswordReason: mustUpdatePasswordReason
                    }
                };
                let $mdPanel = this.$injector.get('$mdPanel');
                $mdPanel.open(config).then((result) => {
                   this.changePasswordDialogRef = result;
                });
            }
        };
        return AuthService;
    }());
    angular.module('shared').service('AuthService', ['$injector','$http', '$q', '$Config', 'localStorageService', 'CacheMemoryService', '$rootScope', "RequestRejector", "MKioskService", "$Loading", "UtilityService", AuthService]);
}(angular));
